import React from 'react';
import Rockets from '../components/Rockets';

const Rocketspage = () => (
  <>
    <Rockets />
  </>
);

export default Rocketspage;
